import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-tabs',
	templateUrl:'./WaTabsPluginCompPage.html',
	styles: [],
	styleUrls:['./WaTabsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaTabsPluginCompPage
{
	mdContent_1146 = `\`\`\`java
import com.jwebmp.webawesome.components.tab.WaTabs;
\`\`\``;
	mdContent_1147 = `\`\`\`java
new WaTabs&lt;&gt;()
\`\`\``;
}
